import React from "react";
import { languages } from "../../constants/languages";
import FileUploader from "react-firebase-file-uploader";
import Button from "@material-ui/core/Button";
import DeleteIcon from "@material-ui/icons/Delete";
import UploadIcon from "@material-ui/icons/CloudUpload";
import CircularProgress from "@material-ui/core/CircularProgress";
import SponsorLinkDialog from "./SponsorLinkDialog";
import { Typography } from "@material-ui/core";
import { validateFileSize } from "../../util/uploadErrors";

const SponsorElement = (props) => (
  <div
    style={{
      minWidth: 250,
      width: 250,
      margin: 5,
      borderRadius: 4,
      overflow: "hidden",
    }}
    className={props.new ? "" : "hoverItemSponsor"}
  >
    {props.errorMessageSponsors &&
      props.errorMessageSponsors.blockNum === props.blockNum &&
      props.errorMessageSponsors.sponsorIndex === props.i && (
        <div>
          <Typography style={{ color: "red" }}>
            {props.errorMessageSponsors.message}
          </Typography>
        </div>
      )}
    <div>
      <div>
        <div
          style={{
            width: "100%",
            border: "1px solid lightgray",
            borderRadius: 4,
          }}
        >
          <div
            style={{
              width: "100%",
              textAlign: "center",
              height: props.new ? 215 : 180,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {props.isUploading &&
            props.uploadingType === "sponsors" &&
            props.uploadingSponsorIndex === props.i &&
            props.uploadingSponsorGroup === props.blockNum ? (
              <CircularProgress size={28} />
            ) : props.sponsor ? (
              <img
                style={{
                  maxWidth: "100%",
                  maxHeight: 180,
                  margin: "auto",
                  verticalAlign: "middle",
                }}
                src={props.sponsor}
                alt=""
              />
            ) : (
              <Typography
                style={{
                  color: "gray",
                  display: "inline-block",
                  width: "100%",
                  textAlign: "center",
                }}
              >
                {languages.tournament.sponsor}
              </Typography>
            )}
          </div>
          {props.sponsor && (
            <div>
              <SponsorLinkDialog
                tournament={props.tournament}
                open={
                  props.openSponsorLinkDialog === props.i &&
                  props.sponsorGroup === props.blockNum
                    ? true
                    : false
                }
                toggleDialog={props.toggleSponsorLinkDialog}
                sponsorIndex={props.i}
                sponsorGroup={props.blockNum}
              />
              <Button
                style={{
                  marginTop: 5,
                  whiteSpace: "nowrap",
                  overflowX: "hidden",
                }}
                size="small"
                fullWidth
                variant="text"
                color="primary"
                onClick={(e) =>
                  props.toggleSponsorLinkDialog(e, props.i, props.blockNum)
                }
                disabled={
                  (props.tournament.isPSD || props.tournament.crqpsd) &&
                  props.i === 0 &&
                  props.blockNum === undefined
                }
              >
                {((props.sponsorLinksTemp
                  ? props.sponsorLinksTemp[
                      props.blockNum !== undefined ? props.blockNum : 0
                    ]
                  : props.tournament[
                      "sponsorLinks" +
                        (props.blockNum !== undefined
                          ? props.blockNum.toString()
                          : "")
                    ]) || [])[props.i]
                  ? ((props.sponsorLinksTemp
                      ? props.sponsorLinksTemp[
                          props.blockNum !== undefined ? props.blockNum : 0
                        ]
                      : props.tournament[
                          "sponsorLinks" +
                            (props.blockNum !== undefined
                              ? props.blockNum.toString()
                              : "")
                        ]) || [])[props.i]
                  : languages.present.sponsorsLink}
              </Button>
            </div>
          )}
          <div
            style={{
              display: props.new ? "" : "flex",
              justifyContent: "space-evenly",
            }}
          >
            <FileUploader
              id={
                "upload-sponsor" +
                props.i +
                (props.blockNum !== undefined ? "-" + props.blockNum : "")
              }
              style={{ display: "none" }}
              accept="image/*"
              name="sponsorUpload"
              randomizeFilename
              storageRef={props.sponsorStorageRef}
              beforeUploadStart={(file) => {
                validateFileSize(file, 1);
              }}
              onUploadStart={() =>
                props.handleUploadStart("sponsors", props.i, props.blockNum)
              }
              onUploadError={(error) => {
                props.handleUploadError(
                  error,
                  "sponsors",
                  props.i,
                  props.blockNum
                );
              }}
              onUploadSuccess={(fileName) => {
                props.handleUploadSuccess(
                  fileName,
                  "sponsors",
                  props.i !== "" ? props.i : undefined,
                  props.blockNum
                );
              }}
              onProgress={props.handleProgress}
            />
            <label
              htmlFor={
                props.allowedToUpload
                  ? (props.tournament.isPSD || props.tournament.crqpsd) &&
                    props.i === 0 &&
                    props.blockNum === undefined
                    ? ""
                    : "upload-sponsor" +
                      props.i +
                      (props.blockNum !== undefined ? "-" + props.blockNum : "")
                  : ""
              }
            >
              <Button
                size="small"
                variant="text"
                component="span"
                color="primary"
                onClick={
                  !props.allowedToUpload ? props.toggleUpgradeDialog : () => {}
                }
                disabled={
                  (props.tournament.isPSD || props.tournament.crqpsd) &&
                  props.i === 0 &&
                  props.blockNum === undefined
                }
                fullWidth={props.new}
              >
                {props.new && languages.tournament.upload}
                <UploadIcon style={{ marginLeft: props.new ? 5 : 0 }} />
              </Button>
            </label>
            {props.sponsor && (
              <Button
                size="small"
                variant="text"
                color="secondary"
                onClick={() =>
                  props.toggleDeleteDialog("sponsors", props.i, props.blockNum)
                }
                disabled={
                  (props.tournament.isPSD || props.tournament.crqpsd) &&
                  props.i === 0 &&
                  props.blockNum === undefined
                }
              >
                <DeleteIcon />
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default SponsorElement;
